
import {Component, Vue} from 'vue-property-decorator';
import {snackbarModule, SnackbarOptions} from '@/store/modules/snackbar';

@Component
export default class AppSnackbar extends Vue {
  @snackbarModule.State('options') snackbar!: SnackbarOptions;
}
